var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentTextOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document_text_outlined",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M8.76,20H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H14a2,2,0,0,1,2,2V12.76a2.98,2.98,0,0,1-.88,2.12l-4.24,4.24A2.981,2.981,0,0,1,8.76,20ZM2,2V18H8V13a1,1,0,0,1,1-1h5V2Zm6.5,8h-4A.5.5,0,0,1,4,9.5v-1A.5.5,0,0,1,4.5,8h4a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,8.5,10Zm3-4h-7A.5.5,0,0,1,4,5.5v-1A.5.5,0,0,1,4.5,4h7a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,11.5,6Z",
    transform: "translate(4 2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentTextOutlined);
export default __webpack_public_path__ + "static/media/document_text_outlined.f78e9317f53e2e66d39d64e9c4624647.svg";
export { ForwardRef as ReactComponent };